export const logo = [
  {
    img: '/logos/logo.jpg'
  },
  {
    img: '/logos/s_logo.png'
  },
  {
    img: '/logos/s_logo_2.png'
  },
  {
    img: 'logos/s_logo_3.png'
  },
  {
    img: '/logos/x_logo.jpg'
  },
  {
    img: 'logos/x_logo.png'
  }
]

export const backgrounds = [
  {
    background: '/backgrounds/background.jpg'
  },
  {
    background: '/backgrounds/background-1.jpg'
  }
]

export const buttons = {
  open: '/buttons/open.png',
  close: '/buttons/close.png'
}

export const educationAndExperience = [
  {
    logo: '/logos/microverse.jpg',
    role: 'Student',
    name: 'Microverse',
    field: 'Software Development',
    year: 'June 2022 - July 2023',
    highlights: [
      'Implement Redux state management in a React App',
      'Work in a team to create a Full Stack Car Bookings Application  using Ruby on Rails, React and Redux',
      'Collaborated in a team to consume an API in a vanilla JS projects',
      'Develop a command-line Library App using Ruby',
      'Develop communication skills while collaborating with my peers from different parts of the world'
    ]
  },
  {
    logo: '/logos/uniport-1.jpeg',
    role: 'Student',
    name: 'University of Port-Harcourt',
    field: 'Gas Engineering',
    year: 'September 2016 - March 2023',
    highlights: [
      'Studied Reservoir Estimation using models',
      'Sub-surface production',
      'Surface production',
      'Pollution Control',
      'Energy Conservation',
      'Natural Gas Processing'
    ]
  },
  {
    logo: '/logos/x_logo.jpg',
    role: 'Full-stack Software Developer',
    name: 'Freelancer',
    field: 'Software Development',
    year: 'January 2023  - Current',
    highlights: [
      'Optimized Image Storing System for a Full Stack Application leading to a 57.6% decrease in API loading times.',
      'Developed and deployed a secure Full Stack Application for Financial Transactions',
      'Led the design, development, and successful deployment of a feature-rich Travel Application using Node.js, React, and MongoDB.',
      'Implemented user authentication and authorization for various applications using industry best practices, safeguarding user data and ensuring secure access to sensitive features.'
    ]
  }
]

export const socials = [
  {
    name: 'FaceBook',
    logo: '/socials/facebook-s.png',
    url: 'https://facebook.com/solomon.akpuru.3'
  },
  {
    name: 'GitHub',
    logo: '/socials/github-sign.png',
    url: 'https://github.com/solobarine'
  },
  {
    name: 'GitLab',
    logo: '/socials/gitlab.png',
    url: 'https://gitlab.com/solobarine'
  },
  {
    name: 'Gmail',
    logo: '/socials/gmail.png',
    url: 'mailto:solobarine@gmail.com?subject=Job%20Offer'
  },
  {
    name: 'LinkedIn',
    logo: '/socials/linkedin.png',
    url: 'https://linkedin.com/in/solomon-akpuru'
  }
]

export const os = [
  {
    name: 'Windows 11',
    imgUrl: '/technologies/os/windows.png'
  },
  {
    name: 'Ubuntu',
    imgUrl: '/technologies/os/ubuntu.png'
  }
]

export const technologies = []

export const about = {
  pitch:
    'Hello and welcome to my website!. My name is Solomon Barine, and I am a Full Stack Developer experienced in creating beautiful and functional web applications. I love experimenting with new technologies and this has helped me develop a strong skill set in a variety of programming languages and frameworks and I am always eager to improve my abilities.In addition to my technical skills, I am also a strong communicator and team player. I believe that clear communication and collaboration are essential for creating successful projects, and I always strive to work closely with my clients and colleagues to achieve their goals. Feel free to contact me if you have a project in mind.'
}
